import { connect } from 'react-redux';
import { RootState } from '../../../../store/reducers';
import ResultsContent from './ResultsContent';
import { SelectedOptions } from '../../../../store/reducers/deltaReducer';
import {
    ANALYSTS, DATA, ENTERPRISE, LEADERSHIP, TARGET, TECHNIQUES, TECHNOLOGY
} from '../../../../store/constants';
import { dataQuestionsScore } from '../delta/data/dataQuestions';
import { enterpriseQuestionsScore } from '../delta/data/enterpriseData';
import { leadershipQuestionsScore } from '../delta/data/leadershipQuestions';
import { targetsQuestionsScore } from '../delta/data/targetsQuestion';
import { analystsQuestionsScore } from '../delta/data/analystsQuestions';
import { techniquesQuestionsScore } from '../delta/data/techniquesData';
import { technologyQuestionsScore } from '../delta/data/technologyQuestions';
import { digitalNative, segments } from '../profile/formData/industrySegments';
import { find } from 'lodash';

export interface ScoreNumbers {
    must: number;
    does: number;
    commitment: number;
}

function getAnswerIndex(answer: string) {
    const splitAnswer = answer.split('question')[1];
    return parseInt(splitAnswer, 10);
}

function getQuestionScore(category: string, selections: SelectedOptions, scores: number[]) {
    const answer = selections[category];
    const answerNumber = getAnswerIndex(answer);

    return scores[answerNumber];
}

function getScores(selectedOptions: SelectedOptions): number {
    const dataScore = getQuestionScore(DATA, selectedOptions, dataQuestionsScore);
    const enterpriseScore = getQuestionScore(ENTERPRISE, selectedOptions, enterpriseQuestionsScore);
    const leadershipScore = getQuestionScore(LEADERSHIP, selectedOptions, leadershipQuestionsScore);
    const targetScore = getQuestionScore(TARGET, selectedOptions, targetsQuestionsScore);
    const analystsScore = getQuestionScore(ANALYSTS, selectedOptions, analystsQuestionsScore);
    const technologyScore = getQuestionScore(TECHNOLOGY, selectedOptions, technologyQuestionsScore);
    const techniquesScore = getQuestionScore(TECHNIQUES, selectedOptions, techniquesQuestionsScore);

    return dataScore + enterpriseScore + leadershipScore +
        targetScore + analystsScore + technologyScore + techniquesScore;
}

interface Median {
    must: number;
    does: number;
    commitment: number;
}

interface NPS {
    must: number;
    does: number;
    satisfied: number;
}

interface Segment {
    id: string;
    label: string;
    score: number;
    median: Median;
    nps: NPS;
}

function getSegment(segment: string): Segment {
    const seg = find(segments, (item) => {
        return item.id === segment;
    });

    const emptyReturn = {
        id: 'notfound',
        label: 'notfound',
        score: 0,
        median: {
            must: 0,
            does: 0,
            commitment: 0
        },
        nps: {
            must: 0,
            does: 0,
            satisfied: 0
        }
    };

    return seg || emptyReturn;
}

function getStage(score: number): string {
    const lowStage1 = score >= 1 && score <= 1.49;
    const highStage1 = score >= 1.5 && score <= 1.99;
    const lowStage2 = score >= 2.00 && score <= 2.49;
    const highStage2 = score >= 2.50 && score <= 2.99;
    const lowStage3 = score >= 3.00 && score <= 3.99;
    const highStage3 = score >= 3.50 && score <= 3.99;
    const lowStage4 = score >= 4.00 && score <= 4.49;
    const highStage4 = score >= 4.50 && score <= 4.99;
    const lowStage5 = score >= 5.00 && score <= 5.49;
    const highStage5 = score >= 5.50 && score <= 5.99;

    if (lowStage1) {
        return 'Low Stage 1';
    } else if (highStage1) {
        return 'High Stage 1';
    } else if (lowStage2) {
        return 'Low Stage 2';
    } else if (highStage2) {
        return 'High Stage 2';
    } else if (lowStage3) {
        return 'Low Stage 3';
    } else if (highStage3) {
        return 'High Stage 3';
    } else if (lowStage4) {
        return 'Low Stage 4';
    } else if (highStage4) {
        return 'High Stage 4';
    } else if (lowStage5) {
        return 'Low Stage 5';
    } else if (highStage5) {
        return 'High Stage 5';
    } else {
        return '';
    }
}

const mapStateToProps = (state: RootState) => {
    const { must, does, commitment } = state.generalReducer;
    const { segment } = state.profileReducer;
    const { median, nps, score: industryScore } = getSegment(segment);
    const yourScore = getScores(state.deltaReducer.selectedOptions);
    const stage = getStage(yourScore);

    const company = { must, does, commitment };

    const industryMedian = {
        must: median.must,
        does: median.does,
        commitment: median.commitment
    };

    const industryNPS = {
        must: nps.must,
        does: nps.does,
        commitment: nps.satisfied
    };

    return {
        company,
        industryMedian,
        industryNPS,
        stage,
        yourScore,
        industryScore,
        digitalNativeScore: digitalNative.score,
        type: 'Localized Analytics'
    };
};

const mapDispatchToProps = () => {
    return {};
};

const ResultsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ResultsContent);

export default ResultsContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/ResultsContainer.tsx